import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import SoftTokensActivateTokenRegisterCodePage, { getDefaultData } from "components/pages/SoftTokensActivateTokenRegisterCodePage";
/**
 * @name CaptureSoftTokenActivationActivateTokenNicknameEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenNicknameEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "registrationCode" ], { value: "913 365 002 813 383 1" })
    .update([ "deviceNickname" ], { value: "Sarah's Phone" })
    .submit();

    return <SoftTokensActivateTokenRegisterCodePage data={ data } />;
}